import { ReactNode } from "react";
import { ApolloProvider } from "../apollo-provider/apollo-provider";

export function GraphQlProvider({ children }: { children: ReactNode }) {
  return <ApolloProvider>{children}</ApolloProvider>;
}
